import { render, staticRenderFns } from "./components.add-reply.vue?vue&type=template&id=2fb2df64&scoped=true"
import script from "./components.add-reply.vue?vue&type=script&lang=js"
export * from "./components.add-reply.vue?vue&type=script&lang=js"
import style0 from "./components.add-reply.vue?vue&type=style&index=0&id=2fb2df64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2df64",
  null
  
)

export default component.exports